// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../mini-css-extract-plugin/dist/loader.js??clonedRuleSet-4.use[1]!../../../css-loader/dist/cjs.js!../../../vue-loader/lib/loaders/stylePostLoader.js!../../../postcss-loader/dist/cjs.js??clonedRuleSet-4.use[3]!../../../sass-loader/dist/cjs.js??clonedRuleSet-4.use[4]!../../../vue-loader/lib/index.js??vue-loader-options!./Vuetable.vue?vue&type=style&index=0&id=5bfa05b0&prod&scoped=true&lang=css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("6a8d76b8", content, true, {});